import React, { useEffect, useCallback, useState} from 'react';
import Dropdown from 'react-dropdown'
import Documented from 'components/help/Documented.js';
import {connect} from 'react-redux';

const AlgoDropdown = ({instrument, algorithm, onChange}) => { 
    const onSelectAlgorithm = useCallback((o) => {
        let algo = o.value;
        instrument.algorithmParameter.set(algo);
    }, []);

    let options = [1,2,3,4,5,6,7,8,9].map(
        a => ({label: a, value: a}));

    return (
        <Documented
          element={instrument.algorithmParameter}
          className="algo-container">
          <div className="algo-label">
            Algorithm: 
          </div>
                <Dropdown
                  className='osc-type-dropdown'
                  controlClassName='osc-type-control-dropdown'
                  arrowClassName='osc-type-arrow-dropdown'
                  options={options}
                  onChange={(o) => onSelectAlgorithm(o)}
                  value={{label: algorithm, value: algorithm}}
                  placeholder="Algorithm" />
        </Documented>
    );
}

const mapStateToProps = (state, props) => {
  return {
      algorithm: props.instrument.algorithmParameter.get()
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AlgoDropdown);
